var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{model:{value:(_vm.offerData.content),callback:function ($$v) {_vm.$set(_vm.offerData, "content", $$v)},expression:"offerData.content"}},[_c('v-icon',{attrs:{"slot":"append"},on:{"click":function($event){return _vm.saveContent(_vm.offerData)}},slot:"append"},[_vm._v("\n    mdi-check\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }